module.exports = require('./helpers/bundle-url').getBundleURL('dwYZa') + "batwoman.34080648.png";